import React from 'react';
import PropTypes from 'prop-types';

const Retry = ({ ...props }) => {
  const { onClick } = props;
  /* return (
    <Card>
      <div className="LoadingScreen">
        <div className="container">
          <h1 align="center">Intentalo de nuevo</h1>
          <p>Parece que te has quedado sin conexión</p>
          <button
            type="button"
            onClick={onClick}
          >
            <span>Reintentar</span>
          </button>
        </div>
      </div>
    </Card>
  ) */
  return null;
}

Retry.propTypes = {
  onClick: PropTypes.func,
}

Retry.defaultProps = {
  onClick: null,
}


export default Retry;
